import React, { createContext, useContext, useState, useCallback } from 'react';

// Native cart context. Checkout is handled natively (see PreorderContext +
// /checkout). There is NO Shopify dependency. This provider keeps the existing
// useCart() interface so consumers (Header, CartDrawer, etc.) work unchanged.
const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const noop = useCallback(() => {}, []);

  return (
    <CartContext.Provider
      value={{
        cart: null,
        items: [],
        count: 0,
        subtotal: 0,
        currency: 'AUD',
        checkoutUrl: null,
        loading: false,
        error: null,
        addItem: noop,
        updateQty: noop,
        removeItem: noop,
        clear: noop,
        isOpen,
        setIsOpen,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error('useCart must be used within CartProvider');
  return ctx;
};
